/* eslint-disable @typescript-eslint/no-unused-vars */

import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import { ClassroomViewModel } from '@/presentation/screens/classroom/classroom.vm';

import Correct from '../icons/Correct-result.svg';
import Grade from '../icons/grade.svg';
import Stats from '../icons/stats.svg';
import Wrong from '../icons/Wrong-result.svg';

const Container = styled.div`
  width: 100%;
  padding: 20px 48px;
  display: flex;
  flex-direction: row;
`;

const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const ContainerQuestions = styled.div`
  width: 100%;
  padding: 20px 48px 92px 48px;
  display: flex;
  flex-direction: column;
`;

const ContainerResult = styled.div`
  width: 100%;
  padding: 20px 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  & > span {
    display: flex;
    flex-direction: row;
  }
`;

const ResultTitle = styled.h2`
  margin-top: 10px;
  font-family: 'Aprova Nova';
  font-size: 32px;
  font-weight: 800;
  line-height: 38px;
  letter-spacing: -1px;
  text-align: left;
`;

const ResultText = styled.div`
  font-family: 'Aprova Nova';
  font-size: 56px;
  font-weight: 800;
  line-height: 64px;
  letter-spacing: -2.4px;
  text-align: left;
  display: flex;
  align-items: normal;

  & > img {
    margin-left: 5px;
  }

  & > p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.2px;
    text-align: left;
    color: #666666;
    margin-left: 7px;
  }
`;

const TotalResult = styled.span<{ last?: boolean }>`
  margin-left: ${(props) => (props.last ? '48px' : '0px')};
`;

const Icon = styled.img`
  max-width: 20px;
  height: 20px;
  fill: #666666;
`;

const ResultQuestion = styled.div<{ correct?: boolean }>`
  color: ${(props) => (props.correct ? '#00c974' : '#DB3D4D')};
  font-family: 'Aprova Nova';
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -1px;
  text-align: left;
  display: flex;
  padding: 30px;
  border-bottom: solid 1px #f5f5f5;

  & > img {
    margin-right: 8px;
    align-self: center;
    max-width: 20px;
  }
`;
const Button = styled.button<{ showButton?: boolean }>`
  background: #00e88f;
  padding: 24px;
  width: 100%;
  font-family: 'Aprova Nova';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.6px;
  border-radius: 0px 0px 8px 8px;
  color: #111111;
  position: absolute;
  bottom: 0;
  @media (max-width: 480px) {
    border-radius: 0;
  }
`;

export const Result: React.FC<any> = ({ vm }) => {
  // const vm = useViewModel(ClassroomViewModel);
  const correct: boolean[] = [];
  const incorrect: boolean[] = [];

  vm.exercises.exercisesQuestion.map((question) => {
    if (question.correct) {
      correct.push(question);
    } else {
      incorrect.push(question);
    }
  });

  const finalGrade =
    correct.length > 0
      ? ((10 * correct.length) / vm.exercises.exercisesQuestion.length).toFixed(1)
      : 0;

  return (
    <>
      <Container>
        <ResultTitle>Seu Resultado</ResultTitle>
      </Container>
      <Container>
        <ContainerResult>
          <ResultText>
            <Icon src={Grade} />
            <p>NOTA</p>
          </ResultText>
          <ResultText>{finalGrade}</ResultText>
        </ContainerResult>

        <ContainerResult>
          <ResultText>
            <Icon src={Stats} />
            <p>ACERTOS E ERROS</p>
          </ResultText>

          <span>
            <ResultText>
              <TotalResult>{correct.length}</TotalResult> <img src={Correct} alt="" />
            </ResultText>
            <ResultText>
              <TotalResult last>{incorrect.length}</TotalResult> <img src={Wrong} alt="" />
            </ResultText>
          </span>
        </ContainerResult>
      </Container>
      <Container>
        <ResultTitle>Aproveitamento</ResultTitle>
      </Container>
      <ContainerQuestions>
        {vm.exercises.exercisesQuestion.map((exercise, index) => {
          return (
            <ResultQuestion key={exercise.guid} correct={exercise.correct}>
              {exercise.correct ? <Icon src={Correct} /> : <Icon src={Wrong} />} Questão {index + 1}
            </ResultQuestion>
          );
        })}
      </ContainerQuestions>
      <ContainerButton>
        <Button
          onClick={() => {
            vm.setShowResult(false);
          }}
        >
          Ver questões
        </Button>
      </ContainerButton>
    </>
  );
};

export default observer(Result);
